import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Dropzone from 'react-dropzone';
import classnames from 'classnames';
import './AddClientOptions.css';

const propTypes = {
  lightTheme: PropTypes.bool,
  onClickManual: PropTypes.func,
  onUpload: PropTypes.func,
};

const defaultProps = {
  lightTheme: false,
  onClickManual: () => {},
  onUpload: () => {},
};

class AddClientOptions extends PureComponent {
  handleBrowseClick = () => {
    this.dropzone.open();
  };

  handleDrop = (files) => {
    if (files && files.length) {
      this.props.onUpload(files[0]);
    }
  };

  render() {
    const { lightTheme, onClickManual } = this.props;

    return (
      <div
        className={classnames('AddClientOptions', {
          'AddClientOptions--light': lightTheme,
        })}
      >
        <a
          href="https://s3.amazonaws.com/sure-host/broker/client_csv_example.csv"
          className="AddClientOptions-sampleLink"
          target="_blank"
          rel="noopener noreferrer"
        >
          <i className="AddClientOptions-sampleLink-icon fas fa-file-download" />
          Download a sample client list
        </a>
        <Dropzone
          className="AddClientOptions-options"
          accept=".csv"
          disableClick={true}
          multiple={false}
          maxSize={9000000}
          activeClassName="is-active"
          onDrop={this.handleDrop}
          ref={(c) => (this.dropzone = c)}
        >
          <div className="AddClientOptions-options-option AddClientOptions-options-option--upload">
            <span className="AddClientOptions-options-option-icon fa-stack fa-2x fa-fw m-t-20">
              <i
                className="far fa-circle fa-stack-2x"
                style={{ color: '#e6e6e6' }}
              />
              <i className="fas fa-file-alt fa-stack-1x" />
            </span>
            <p className="AddClientOptions-options-option-prompt">
              Drag and drop a .CSV here to add multiple clients at once
            </p>
            <button
              className="AddClientOptions-options-option-cta btn btn-complete"
              onClick={this.handleBrowseClick}
            >
              <span className="AddClientOptions-options-option-cta-icon fas fa-cloud-upload-alt" />
              Browse
            </button>
          </div>
          <div className="AddClientOptions-options-divider">or</div>
          <div className="AddClientOptions-options-option AddClientOptions-options-option--manual">
            <span className="AddClientOptions-options-option-icon fa-stack fa-2x fa-fw m-t-20">
              <i
                className="far fa-circle fa-stack-2x"
                style={{ color: '#e6e6e6' }}
              />
              <i className="fas fa-user-plus fa-stack-1x" />
            </span>
            <p className="AddClientOptions-options-option-prompt">
              MANUALLY ADD A CLIENT TO YOUR CLIENT LIST
            </p>
            <button
              className="AddClientOptions-options-option-cta btn btn-default"
              onClick={onClickManual}
            >
              <span className="AddClientOptions-options-option-cta-icon fas fa-plus" />
              Add Client
            </button>
          </div>
        </Dropzone>
        <p className="AddClientOptions-disclaimer">
          Your clients will never be contacted for the marketing of additional
          products or services without your permission.
        </p>
      </div>
    );
  }
}

AddClientOptions.propTypes = propTypes;
AddClientOptions.defaultProps = defaultProps;

export default AddClientOptions;
